import React from 'react'
import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import { RxWebSocketStatus, RxWebSocketReadyState } from 'messaging'
import { LoaderAnimation } from 'view/components/loader/Loader'
import * as constants from 'view/styles/constants'

export interface StatusPanelProps {
  statuses: RxWebSocketStatus[]
}

const StatusPanelContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${constants.CORE_PRIMARY};
`
const StatusPanelMessage = styled.div`
  margin: 24px 0;
`

export class StatusPanel extends React.Component<StatusPanelProps> {
  render() {
    const { statuses } = this.props
    const lastMessage = statuses.length ? this.formatStatus(statuses[statuses.length - 1]) : '\xa0'

    return (
      <StatusPanelContainer>
        <LoaderAnimation />
        <StatusPanelMessage data-test-id="StatusPanelMessage">{lastMessage}</StatusPanelMessage>
      </StatusPanelContainer>
    )
  }

  private formatStatus(status: RxWebSocketStatus) {
    switch (status.readyState) {
      case RxWebSocketReadyState.Connecting:
        return Locale.translate(Translation.SC_CONNECTING_TO, status)
      case RxWebSocketReadyState.Closing:
        return Locale.translate(Translation.SC_DISCONNECTING_FROM, status)
      case RxWebSocketReadyState.Open:
        return Locale.translate(Translation.SC_CONNECTED_TO, status)
      case RxWebSocketReadyState.Closed:
        return Locale.translate(Translation.SC_DISCONNECTED_FROM, status)
      case RxWebSocketReadyState.Errored:
        return Locale.translate(Translation.SC_FAILED_TO_CONNECT_TO, status)
      default:
        throw new Error(`Unhandled readyState ${(status as any).readyState}`)
    }
  }
}
